export default {
    thickness: 2,
    radius: 25,
    color: 0x232323,
    followSpeed: 0.2,
    scaledPadding: 10,
};
